import possibleFunctions from "../../possibleFunctions";
import React from "react";

export const FunctionModifier = (props) => {
    const {state, handleToggleModifier} = props
    const funcName = state?.func?.funcName;

    return (
        <div className="predicate-group-header">
            <div className="selected-func">
                <div className="label and-label">{funcName}</div>
            </div>
            <div className="func-options">
                {Object.keys(possibleFunctions).map((modifierFunctionKey, index) => {
                    if (funcName !== modifierFunctionKey) {
                        return <div className="label" key={index}
                                    onClick={() => handleToggleModifier(modifierFunctionKey)}>{(possibleFunctions[modifierFunctionKey])}
                        </div>
                    }
                })}
            </div>
        </div>
    )
}